import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import moment from 'moment/moment';

const columns = [
    {
        name: 'Name',
        selector: (row) => row.name,
    },
    {
        name: 'Status',
        selector: (row) => row.status,
    },
    {
        name: 'Company',
        selector: (row) => row.company,
    },
    {
        name: 'Assign To',
        selector: (row) => row.assignTo,
    },
    {
        name: 'Added Date',
        selector: (row) => moment(row.createdAt).format('DD/MM/YYYY'),
    },
    {
        name: 'Due Date',
        selector: (row) => moment(row.dueDate).format('DD/MM/YYYY'),
    },
];

const OnProcessTask = () => {
    const [data, setData] = useState([])
    const [pages, setPages] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalRows, setTotalRows] = useState(0)

    const fetchData = async () => {
        try {
            const response = await axiosAuthInstance.get('task/list', {
                page: pages, limit: limit, isOnPrcess: true
            })
            if (response && response.status === 200) {
                const transformedData = response.data.result.docs
                setData(transformedData)
                setTotalRows(response.data.result.totalDocs)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        fetchData()
    }, [pages, limit])

    const handlePageChange = (newPage) => {
        setPages(newPage)
    }

    const handleLimitPerPageChange = (newLimit) => {
        setLimit(newLimit)
        setPages(1)
    }

    return (
        <>
            <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                On Process
            </h2>
            <DataTable
                columns={columns}
                data={data}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={limit}
                paginationRowsPerPageOptions={[10, 20, 30]}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handleLimitPerPageChange}
            />
        </>
    )
}

export default OnProcessTask
